const mistakes = [
  { title: "Waiting Too Long", desc: "Little Rock residents often wait until 2 weeks before travel to start. Start at least 3–4 weeks early to avoid rush fees and stress." },
  { title: "Wrong Photo Size", desc: "CVS and Walgreens photos are often rejected. We provide exact specs and review your photo before submission." },
  { title: "Missing Documents", desc: "Birth certificates without a raised seal are commonly rejected. We verify all your documents before you visit the acceptance facility." },
  { title: "Booking Travel Before Passport", desc: "Never book non-refundable flights before verifying your passport is valid. We see this mistake weekly from Little Rock travelers." },
  { title: "Using the Wrong Form", desc: "DS-11 vs DS-82 confusion causes major delays. We tell you exactly which form to use based on your situation." },
];

export default function LittleRockMistakesSection() {
  return (
    <section id="mistakes" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Mistakes Little Rock Applicants Make</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className="ri-close-circle-line text-red-500 text-xl"></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}